import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnBuildingHost = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M3 21h18M7.5 16.05h2.7m3.6 0h2.7M7.5 12h2.7m3.6 0h2.7m-9-4.05h2.7m3.6 0h2.7m0-4.95h-9C4.8 3 3.9 4.611 3.9 6.6V21h16.2V6.6c0-1.989-.9-3.6-3.6-3.6"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnBuildingHost;
